/* eslint-disable */
export default [
    {
        path: '/product-mgmt',
        name: 'product-mgmt',
        component: () => import(/* webpackChunkName: "product" */ '@/views/products/ProductMgmt.vue'),
        meta: {
            pageTitle: 'Devices',
            breadcrumb: [
                {
                    text: 'Shop',
                },
                {
                    text: 'Products',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/oppo',
        name: 'don-hang-oppo',
        component: () => import(/* webpackChunkName: "product" */ '@/views/b2c/DeviceOrders.vue'),
        meta: {
            pageTitle: 'Devices',
            breadcrumb: [
                {
                    text: 'Shop',
                },
                {
                    text: 'Products',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/baseus',
        name: 'don-hang-baseus',
        component: () => import(/* webpackChunkName: "product" */ '@/views/b2c/BaseusOrders.vue'),
        meta: {
            pageTitle: 'Devices-Baseus',
            breadcrumb: [
                {
                    text: 'Shop',
                },
                {
                    text: 'Products',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/quan-ly-menu-phu-kien',
        name: 'quan-ly-menu-phu-kien',
        component: () => import(/* webpackChunkName: "product" */ '@/views/b2c/admin/AdminCategories.vue'),
        meta: {
            pageTitle: 'Devices',
            breadcrumb: [
                {
                    text: 'Shop',
                },
                {
                    text: 'Products',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/quan-ly-san-pham-kham-pha',
        name: 'Quản lý sản phẩm khám phá',
        component: () => import(/* webpackChunkName: "product" */ '@/views/b2c/admin/AdminProductDiscover.vue'),
        meta: {
            pageTitle: 'Devices',
            breadcrumb: [
                {
                    text: 'Shop',
                },
                {
                    text: 'Products',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/product-mgmt/product-type',
        name: 'product-type',
        component: () => import(/* webpackChunkName: "product" */ '@/views/products/ProductMasterData.vue'),
        meta: {
            pageTitle: 'Loại sản phẩm',
            type: 'product_types',
            breadcrumb: [
                {
                    text: 'Products',
                },
            ],
        },
    },
    {
        path: '/product-mgmt/categories',
        name: 'categories',
        component: () => import(/* webpackChunkName: "product" */ '@/views/products/ProductMasterData.vue'),
        meta: {
            pageTitle: 'Danh mục sản phẩm',
            type: 'categories',
            breadcrumb: [
                {
                    text: 'Products',
                },
            ],
        },
    },
    {
        path: '/product-mgmt/product-type-discounts',
        name: 'product-type-discounts',
        component: () => import(/* webpackChunkName: "product" */ '@/views/products/ProductMasterData.vue'),
        meta: {
            pageTitle: 'Giảm giá theo loại sản phẩm',
            type: 'product_type_discounts',
            breadcrumb: [
                {
                    text: 'Products',
                },
            ],
        },
    },
    {
        path: '/product-mgmt/md-units',
        name: 'md-units',
        component: () => import(/* webpackChunkName: "product" */ '@/views/products/ProductMasterData.vue'),
        meta: {
            pageTitle: 'Đơn vị tính',
            type: 'md_units',
            breadcrumb: [
                {
                    text: 'Products',
                },
            ],
        },
    },
]
